module.exports = __webpack_public_path__ + "static/media/portfolio3.0ecf6067.jpeg";